export const TOUR_DRAWER = '|A|TOUR_DRAWER'
export const LIBRARY_DRAWER = '|A|LIBRARY_DRAWER'
export const STOP_LIST_DRAWER = '|A|STOP_LIST_DRAWER'
export const STOP_DESCRIPTION_DRAWER = '|A|STOP_DESCRIPTION_DRAWER'
export const MAP_DRAWER = '|A|MAP_DRAWER'
export const HIDE_DRAWER = 'HIDE_DRAWER'
export const STOP_FADER_DRAWER = '|A|STOP_FADER_DRAWER'
export const STOP_LIST_SCROLL = '|A|STOP_LIST_SCROLL'
export const STOP_LIST_ITEM_SELECTED = '|A|STOP_LIST_ITEM_SELECTED'
export const VR_INSTRUCTION_DRAWER = '|A|VR_INSTRUCTION_DRAWER'

export const openDrawer = type => ({
    type,
})

export const showVRInstructionDrawer = () => ({
    type: VR_INSTRUCTION_DRAWER,
})

/**
 * Show Stop Drawer Fader
 * @param float y offset for y position for stop drawer, typically derived from the mouse.
 * @param bool userTriggered indication if the user triggered this, used to cancel auto-dismiss
 */
export const showStopFaderDrawer = (y, userTriggered) => {
    return {
        type: STOP_FADER_DRAWER,
        y,
        userTriggered,
    }
}

export const stopListScrolled = () => ({
    type: STOP_LIST_SCROLL,
})

export const stopListItemClicked = stop => ({
    type: STOP_LIST_ITEM_SELECTED,
    stop,
})

export const showLibraryDrawer = () => {
    return {
        type: LIBRARY_DRAWER,
    }
}

export const showTourDrawer = () => {
    return {
        type: TOUR_DRAWER,
    }
}

export const showStopListDrawer = () => {
    return {
        type: STOP_LIST_DRAWER,
    }
}

export const showStopDescriptionDrawer = () => ({
    type: STOP_DESCRIPTION_DRAWER,
})

export const showMapDrawer = () => {
    return {
        type: MAP_DRAWER,
    }
}

export const hideDrawer = () => {
    return {
        type: HIDE_DRAWER,
    }
}
